import {Link} from '@remix-run/react'
import {type VariantProps} from 'class-variance-authority'
import * as React from 'react'

import {cn} from '#app/utils/misc'

import {buttonVariants} from './button'

export interface LinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof buttonVariants> {
  to: string
  children: React.ReactNode
  disabled?: boolean
}

const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({children, className, variant, size, disabled, ...props}, ref) => {
    return (
      <Link
        className={cn(
          buttonVariants({variant, size, className}),
          disabled && 'pointer-events-none opacity-50',
        )}
        ref={ref}
        {...props}
      >
        {children}
      </Link>
    )
  },
)
LinkButton.displayName = 'LinkButton'

export {LinkButton, buttonVariants}
